import { Box, BoxProps as IBoxProps, styled } from "@mui/material";

export const LayoutWrapper = styled(
  Box,
  {},
)<Partial<IBoxProps>>(({ theme }) => ({
  ".main-container": {
    display: "flex",
    gap: "2.5rem",
    marginTop: "4rem",
    [theme.breakpoints.up("xl")]: {
      marginTop: "4.5rem",
    },
    [theme.breakpoints.between("lg", "xl")]: {
      marginTop: "4rem",
    },
    [theme.breakpoints.between("md", "lg")]: {
      marginTop: "3.783rem",
    },
    [theme.breakpoints.between("sm", "md")]: {
      marginTop: "3.649rem",
    },
    [theme.breakpoints.between("xs", "sm")]: {
      display: "flex",
      flexDirection: "column",
      marginTop: "3.887rem",
    },
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "column",
      marginTop: "3.667rem",
    },
    ".sidebar": {
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(2),
      borderRight: "1px solid #e2f0e2",
    },
    ".main-content": {
      display: "flex",
      width: "100%",
      minHeight: "90vh",
      [theme.breakpoints.down("sm")]: {
        marginTop: "3.5rem",
        minHeight: "60vh",
      },
    },
  },
}));
